// src/portals/fan/pages/DiscoverPage/components/creatorPreview/EventCard.js
import React, { useState } from "react";
import Card from "../../../../../../components/ui/Card";
import Button from "../../../../../../components/ui/Button";
import CheckoutModal from "../../../../../../components/shared/CheckoutModal";
import { Calendar, MapPin } from "lucide-react";

const EventCard = ({ event }) => {
  const [isCheckoutOpen, setCheckoutOpen] = useState(false);
  const itemForCheckout = { ...event, name: event.title, type: "Event Ticket" };

  return (
    <>
      <Card>
        <p className={`...`}>{event.type}</p>
        <h3 className="font-bold text-lg text-text-primary mt-1">
          {event.title}
        </h3>
        <div className="text-sm text-text-secondary space-y-1 mt-2">
          <p className="flex items-center">
            <Calendar size={14} className="mr-2" /> {event.date}
          </p>
          <p className="flex items-center">
            <MapPin size={14} className="mr-2" />{" "}
            {event.location || event.platform}
          </p>
        </div>
        <Button
          onClick={() => setCheckoutOpen(true)}
          variant="secondary"
          size="md"
          className="w-full mt-4"
        >
          Get Tickets
        </Button>
      </Card>
      <CheckoutModal
        isOpen={isCheckoutOpen}
        onClose={() => setCheckoutOpen(false)}
        item={itemForCheckout}
      />
    </>
  );
};

export default EventCard;
